import { BaseQuery2 } from '@/utils';

/**
 * @startDate
 * @endDate
 * @originProvinceAreas // 始发省区
 * @destinationProvinceArea // 目的省区
 * @originProvinceArea // 当前始发省区
 * @originSiteName // 当前始发分拨
*/
export const TableQuery = params => {
  const andFilters = [{key: 'scanType', value: '录单'}];
  if (params.originProvinceArea) {
    andFilters.push({key: 'originProvinceArea', value: params.originProvinceArea})
  }
  if (params.originSiteName) {
    andFilters.push({key: 'originCenter', value: params.originSiteName})
  }
  return [
    {
      // 获取所有省区
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['originProvinceArea'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: andFilters,
      inFilters: params.originProvinceArea || params.originSiteName ? [] : 
        [{key: 'originProvinceArea', value: params.destinationProvinceAreas}
      ],
    },
    {
      // 1
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['originProvinceArea', 'destinationProvinceArea'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: andFilters,
      inFilters: [
        {key: 'destinationProvinceArea', value: params.destinationProvinceAreas}
      ]
    },
  ]
}